import { INote } from "../Note";
import { BaseEntity } from "../system";

export enum AccountStatus {
  Archived,
  Disabled,
  Enabled,
}

export enum AccountType {
  Auto,
  Manual,
  eBay,
  PartPro,
  Shopify,
  Reuse,
  Remanufacturing,
  Reintegration,
  Recycling
}

export interface IAccount extends BaseEntity {
  accountNumber: number;
  name: string;
  status: AccountStatus;
  accountType: AccountType;
  billingAddressId?: string;
  shippingAddressId?: string;
  primaryContactId?: string;
  vatNumber?: string;
  creditLimit: number;
  accountNotes: INote[];
  bankAccountName: string;
  bankAccountNumber: string;
  bankSortCode: string;
  deleted?: string;
}

export interface AccountCreateEditRequest
  extends Omit<
    IAccount,
    "id" | "created" | "updated" | "deleted" | "accountNumber"
  > { }

export interface AccountCreateEditFormFields
  extends Omit<AccountCreateEditRequest, "creditLimit"> {
  creditLimit: string;
  regularsAccount: boolean;
}
